export default __webpack_public_path__ + "static/mission-illus-b4ea38bc90d292babf70c6c23aa04309.svg";